import React from 'react';
import { Card, CardContent, CircularProgress, Grid, IconButton, ListItemIcon, ListItemText, MenuItem, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import config from 'src/config';
import Swal from 'sweetalert2';
import { getContainerAuditLogs } from 'src/services/container.service';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import moment from 'moment';
import { actionsMap } from './data';
import { formatDate } from 'src/methods/common.methods';

// ----------------------------------------------------------------------



class ContainerAuditLogModal extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			view_type: this.props.view_type || 'menu',
			is_modal_open: false,
			loading: false,

			container_audit_logs: [],
		}
	}

	async fetchContainerAuditLogs() {

		const container_audit_logs = await getContainerAuditLogs(this.props.container._id);
		if (!container_audit_logs) {
			return;
		}
		if (container_audit_logs.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: container_audit_logs.error,
				confirmButtonText: 'Ok',
				confirmButtonColor: config.primaryColor
			});
			return;
		}

		await this.setState({
			container_audit_logs: container_audit_logs.container_audit_logs || [],
			loading: false
		});

	}
		

	ContainerAuditLogTable = () => {

		if (this.state.container_audit_logs.length === 0) {
			return (
				<Typography variant="h6" align="center" sx={{ opacity: 0.6 }}>
					No audit logs found for this container.
				</Typography>
			);
		}

		return (
			<TableContainer component={Paper}>
				<Table sx={{ width: '100%' }} aria-label="audit log table">
					<TableHead>
						<TableRow>
							<TableCell>User</TableCell>
							<TableCell>Action</TableCell>
							<TableCell>Info</TableCell>
							<TableCell>Timestamp</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{this.state.container_audit_logs.map((audit_log) => (
							<TableRow
								key={audit_log._id}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell component="th" scope="row">
									{audit_log.user.username}
								</TableCell>
								<TableCell>{actionsMap[audit_log.action]}</TableCell>
								<TableCell>
									{audit_log.name_updated ? (
										<div>Name : {audit_log.name_updated}</div>
									) : null}
									{(audit_log?.users_added && audit_log.users_added.length > 0) ? (
										<div>Users Added : {audit_log.users_added.map(user => user.username).join(', ')}</div>
									) : null}
									{(audit_log?.users_removed && audit_log.users_removed.length > 0) ? (
										<div>Users Removed : {audit_log.users_removed.map(user => user.username).join(', ')}</div>
									) : null}
									{(audit_log?.files_added && audit_log.files_added.length > 0) ? (
										<div>Files Added : {audit_log.files_added.map(file => file.name).join(', ')}</div>
									) : null}
									{(audit_log?.files_removed && audit_log.files_removed.length > 0) ? (
										<div>Files Removed : {audit_log.files_removed.map(file => file.name).join(', ')}</div>
									) : null}
								</TableCell>
								<TableCell>{formatDate(audit_log.created_at)}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		);
	}

	render() {
		return (
			<>
			{(this.state.view_type == 'menu') ? (
				<MenuItem
					onClick={() => {
						this.setState({
							is_modal_open: true,
							loading: true
						});
						this.fetchContainerAuditLogs();
					}}
				>
					<ListItemIcon>
						<FeaturedPlayListIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						View Audit Log
					</ListItemText>
				</MenuItem>
			) : null}
			{(this.state.view_type == 'icon') ? (
				<IconButton
					onClick={() => {
						this.setState({
							is_modal_open: true,
							loading: true
						});
						this.fetchContainerAuditLogs();
					}}
					size='small'
				>
					<FeaturedPlayListIcon />
				</IconButton>
			) : null}
			<Modal
				open={this.state.is_modal_open}
				onClose={() => {
					if (this.props.onClose) {
						this.props.onClose();
					}
					this.setState({
						is_modal_open: false
					});
				}}
			>
				<Grid container>
					<Grid item style={modalStyle} xs={12} md={10} lg={8}>
						<Card variant='outlined'>
							<CardContent style={{ padding: 20 }}>
								{(this.state.loading) ? (
									<CircularProgress />
								) : null}
								{(!this.state.loading) ? (
									this.ContainerAuditLogTable()
								) : null}
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Modal>
			</>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	maxHeight: '90%',
	overflowY: 'auto'
};

export default function (props) {
	return <ContainerAuditLogModal {...props} />;
}
